import { DealRequest } from "@/app/api/types";
import { ClarificationModalRef } from "@/features/factor-request-clarification-modal/types";
import { ClarificationItem } from "@/widgets/clarification-item";
import { Stack, SxProps } from "@mui/material";
import { FC } from "react";

interface Props {
  deal: DealRequest;
  sx?: SxProps;
  openClarificationModal?: ClarificationModalRef["open"];
}

export const SingleDealClarifications: FC<Props> = ({
  deal,
  sx,
  openClarificationModal,
}) => {
  return (
    <Stack sx={sx} spacing={2}>
      {deal.clarifications.map((c) => (
        <ClarificationItem
          key={c.unique}
          data={c}
          openClarificationModal={openClarificationModal}
        />
      ))}
    </Stack>
  );
};
